<template>
  <!-- This component doesn't render anything visible -->
</template>

<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router';
import { onMounted, watch } from 'vue';

const route = useRoute();
const router = useRouter();

// Function to clean URL parameters
const cleanUrlParams = () => {
  if (route.query.error === 'login_required' || route.query.iss) {
    // Create a new query object without the error and iss parameters
    const newQuery = { ...route.query };
    delete newQuery.error;
    delete newQuery.iss;
    
    // Replace the current URL without these parameters
    // Using nextTick to ensure this happens after the current render cycle
    nextTick(() => {
      router.replace({
        path: route.path,
        query: newQuery,
        hash: route.hash
      });
    });
  }
};

// Check on component mount
onMounted(() => {
  // We need to wait for client-side hydration to complete
  setTimeout(() => {
    cleanUrlParams();
  }, 0);
});

// Also watch for route changes to handle cases where the URL might change after mount
watch(
  () => route.fullPath,
  () => {
    cleanUrlParams();
  }
);
</script>
